import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { HeartIcon, HandIcon, ThermometerIcon, MoonIcon } from 'lucide-react';
const benefits = [{
  icon: HeartIcon,
  title: 'The Vagus "C-Pat"',
  description: 'The exact rhythm that mimics your heartbeat and forces the baby\'s brain into a deep "Rest & Digest" state.'
}, {
  icon: HandIcon,
  title: 'The 4-Stage Lowering',
  description: 'Where to touch the mattress first (it\'s not their back) to prevent the "falling" reflex.'
}, {
  icon: ThermometerIcon,
  title: 'The Pre-Heat Protocol',
  description: 'How to eliminate the "Cold Shock" that wakes 80% of babies during the transfer.'
}, {
  icon: MoonIcon,
  title: 'The "Heavy Hand" Technique',
  description: 'How to fade your presence so they stay asleep for hours, not minutes.'
}];
export function BenefitsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-20 px-4 bg-cream" data-id="element-1">
      <div className="max-w-6xl mx-auto" data-id="element-2">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8
      }} className="text-4xl md:text-5xl font-serif font-bold text-charcoal text-center mb-16" data-id="element-3">
          Inside the Reset Guide, you'll discover:
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-4">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <motion.div key={benefit.title} initial={{
            opacity: 0,
            y: 30
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 30
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow" data-id="element-5">
                <div className="flex items-start space-x-4" data-id="element-6">
                  <div className="flex-shrink-0 w-14 h-14 bg-sage/10 rounded-full flex items-center justify-center" data-id="element-7">
                    <Icon className="w-7 h-7 text-sage" aria-hidden="true" data-id="element-8" />
                  </div>
                  <div className="flex-1" data-id="element-9">
                    <h3 className="text-xl md:text-2xl font-serif font-bold text-charcoal mb-3" data-id="element-10">
                      {benefit.title}
                    </h3>
                    <p className="text-charcoal/70 leading-relaxed" data-id="element-11">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}